import {
  queryOrderPages,
  cancelOrder,
  getOrderDetail,
  updateOrderStoreReceive,
  payAndCompletion,
  updateOrderSellerRemark,
  dealWithDelivery,
  updateOrderExpress,
  payResult,
  queryOrderPickupCode,
  exportOrderExcel,
  exportOrder,
  confirmOrder,
  downloadOrderDeliveryTemplate,
  downloadOrderReceivedTemplate,
  queryWtOrderStatusCount,
  queryWtOrderPage,
  querWtDeclaration,
  dealWithDeliveryBatch,
  bulkdelivery,
  wtCreateReturn,
  downloadOrderPayTemplate,
  findCompressedDeclarationStatus,
  getPCRAttr,
  queryBaseStorePage
} from "@/graphql/wtOrder.gql";
import { easyMutate, moneyFormat, resRest } from "@root/lib/utils";
import gql from "graphql-tag";

const expandExtProps = (data: any) => {
  let { extProps = null, ...others } = data || {};

  let exProsObject = {
    plateNo: "-"
  };

  if (extProps) {
    try {
      exProsObject = JSON.parse(extProps);
    } catch (err) {
      console.error(err);
    }
  }

  return {
    ...exProsObject,
    ...others
  };
};

export default {
  namespaced: true,
  state: {
    orderList: [],
    StatusCountList: [],
    orderDetails: null,
    dealWithDeliveryRes: {},
    orderSellerRes: {},
    orderExpressRes: {}
  },
  getters: {
    // getOrderTabList() {
    //   let tabList = [
    //     { label: i18nTs("Basic.order_items"), name: "label1" },
    //     { label: i18nTs("Basic.Order_Promotions"), name: "label2" },
    //     { label: i18nTs("O2OOrder.payment_info"), name: "label3" },
    //     { label: i18nTs("Refund.change_log"), name: "label4" }
    //   ];
    //   return tabList;
    // }
  },
  actions: {
    // 订单列表
    async queryWtOrderPage({ commit, rootState }, variables) {
      const {
        data,
        data: {
          api: { pageInfo }
        }
      } = await rootState.gql.query({
        query: queryWtOrderPage,
        variables
      });

      let list = resRest(data);
      let result: any = list.map(item => {
        let hasExtprop: any = 0;
        item.orderProductOutList = item.orderProductOutList.map(sku => {
          if (sku.extProps) {
            const { isExpress, cartType } = JSON.parse(sku.extProps || {});
            sku.isExpress = isExpress;
            sku.cartType = cartType;
          }
          
          if (sku.cartType) {
            hasExtprop++;
          }
          return sku;
        });
        if (!hasExtprop) {
          // 如果所有商品里都没有返回extProps字段，则认为是在经销商活动商品和佳通活动商品合并结算改版之前下的单，订单里只有一种活动商品（经销商活动商品或者佳通活动商品）
          // 这个时候商品行没有返回extProps，无法知道是哪种类型的活动商品，则取订单行的信息
          item.isOldOrder = true;
          item.JTProduct =
            item.orderTypeWt=== "7";
          item.isExpress =
            item.JTProduct && item.distributionType === "11" ? 1 : 2;
        }
        return item;
      });
      list = result;
      // const list = dataList.map(item => {
      //   const {
      //     amount,
      //     currencyCode,
      //     store = { storeName: "", storeCode: "" },
      //     shop = { shopName: "" },
      //     ...others
      //   } = expandExtProps(item.node);

      //   return {
      //     amountString: `${moneyFormat(amount)} ${currencyCode}`,
      //     amount,
      //     store,
      //     ...shop,
      //     ...store,
      //     ...others
      //   };
      // });

      commit("easyMutate", { path: "orderDataList", data: list });

      return {
        total: pageInfo.total,
        list: list
      };
    },
    // 订单列表
    async queryOrderPages({ commit, rootState }, data) {
      const res = await rootState.gql.query({
        query: queryOrderPages,
        variables: {
          ...data
        }
      });

      const { dataList, pageInfo } = res.data.api;

      const list = dataList.map(item => {
        const {
          amount,
          currencyCode,
          store = { storeName: "", storeCode: "" },
          shop = { shopName: "" },
          ...others
        } = expandExtProps(item.node);

        return {
          amountString: `${moneyFormat(amount)} ${currencyCode}`,
          amount,
          store,
          ...shop,
          ...store,
          ...others
        };
      });

      commit("easyMutate", { path: "orderList", data: list });

      return {
        total: pageInfo.total,
        list: list
      };
    },
    // 订单列表
    async queryWtOrderStatusCount({ commit, rootState }, data) {
      const {
        data: { api }
      } = await rootState.gql.query({
        query: queryWtOrderStatusCount,
        variables: {
          ...data
        }
      });

      commit("easyMutate", {
        path: "StatusCountList",
        data: api
      });

      return api;
    },

    // 订单取消
    async cancelOrder({ commit, rootState }, data) {
      await rootState.gql.mutate({
        mutation: cancelOrder,
        variables: {
          orderCancelInput: data
        }
      });
    },

    // 报单
    async querWtDeclaration({ commit, rootState }, variables) {
      await rootState.gql.query({
        query: querWtDeclaration,
        variables
      });
    },
    /**
     * 批量报单
     * @param param0
     * @param variables
     */
    async bulkdelivery({ commit, rootState }, variables) {
      return await rootState.gql.query({
        query: bulkdelivery,
        variables
      });
    },
    /**
     * 批量发货
     * @param param0
     * @param variables
     */
    async dealWithDeliveryBatch({ commit, rootState }, variables) {
      return await rootState.gql.query({
        query: dealWithDeliveryBatch,
        variables
      });
    },
    // 订单强制完成
    async payAndCompletion({ commit, rootState }, input) {
      await rootState.gql.mutate({
        mutation: payAndCompletion,
        variables: {
          input
        }
      });
    },

    // 订单详情
    async getOrderDetail({ commit, rootState }, data) {
      const { orderCode } = data;
      const res = await rootState.gql.query({
        query: getOrderDetail,
        variables: {
          orderCommonInput: {
            orderCode
          }
        }
      });

      const info = expandExtProps(res.data.api);

      commit("easyMutate", {
        path: "orderDetails",
        data: info
      });

      return info;
    },

    // 更新订单的门店和预约时间信息
    async updateOrderStoreReceive({ commit, rootState }, data) {
      const res = await rootState.gql.mutate({
        mutation: updateOrderStoreReceive,
        variables: {
          updateOrderStoreReceiveInput: data
        }
      });

      if (!res.data.api.success) {
        throw new Error("false");
      }

      return res.data.api.success;
    },

    // 发货
    async dealWithDelivery({ commit, rootState }, data) {
      const res = await rootState.gql.mutate({
        mutation: dealWithDelivery,
        variables: {
          orderDeliveryInput: data
        }
      });
      commit("easyMutate", {
        path: "dealWithDeliveryRes",
        data: res
      });

      return res.data.api;
    },
    // 取消订单
    async wtCreateReturn({ commit, rootState }, data) {
      return await rootState.gql.mutate({
        mutation: wtCreateReturn,
        variables: data
      });
    },

    // delivery
    async dealWithReceived({ commit, rootState }, data) {
      // dataList 入参
      let dataList = data instanceof Array ? data : [data];

      let queryJoin = dataList => {
        return dataList
          .map(({ orderCode }, index) => {
            return `
                dealWithReceived_${index}: dealWithReceived(orderDeliveryInput:$orderDeliveryInput${index}) {
                  result
                  orderCode
                  orderType
                  tradeSource
                  channelCode
                }`;
          })
          .join(",");
      };

      // 返回结果
      let res = null;

      try {
        // variablesJoin 入参  variablesJoin 变量
        let variablesInputs = {};
        let variablesJoin = dataList
          .map((v, index) => {
            let e = `$orderDeliveryInput${index}: OrderDeliveryInput!`;
            let {
              orderCode,
              expressCode,
              companyCode,
              companyName,
              orderDeliveryDtlIns
            } = v;
            let inputEle = {
              orderCode,
              expressCode,
              companyCode,
              companyName,
              orderDeliveryDtlIns
            };
            let i = `orderDeliveryInput${index}`;
            variablesInputs[i] = inputEle;

            return e;
          })
          .toString();

        res = await rootState.gql.mutate({
          mutation: gql`
              mutation dealWithReceived(${variablesJoin}){
                ${queryJoin(dataList)}
              }`,
          variables: variablesInputs
        });
        return res;
      } catch (err) {
        console.error(err);
      }
    },
    // 更新卖家备注
    async updateOrderSellerRemark({ commit, rootState }, data) {
      const res = await rootState.gql.mutate({
        mutation: updateOrderSellerRemark,
        variables: {
          orderSellerRemarkInput: data
        }
      });
      commit("easyMutate", {
        path: "orderSellerRes",
        data: res
      });

      return res.data.api.success;
    },

    // 更新发货信息
    async updateOrderExpress({ commit, rootState }, data) {
      const res = await rootState.gql.mutate({
        mutation: updateOrderExpress,
        variables: {
          orderDeliveryInput: data
        }
      });
      commit("easyMutate", {
        path: "orderExpressRes",
        data: res
      });
      return res.data.api.result;
    },

    // 线下确认支付
    async confirmPay({ commit, rootState }, data) {
      const res = await rootState.gql.mutate({
        mutation: payResult,
        variables: {
          orderPaymentInput: data
        }
      });
      return res.data.api;
    },

    async exportOrderExcel({ rootState }, data) {
      await rootState.gql.query({
        query: exportOrderExcel,
        variables: data
      });
    },
    async exportOrder({ rootState }, data) {
      await rootState.gql.query({
        query: exportOrder,
        variables: data
      });
    },
    // 确认订单
    async confirmOrder({ rootState }: any, orderCommonInput) {
      const {
        data: { api }
      } = await rootState.gql.mutate({
        mutation: confirmOrder,
        variables: {
          orderCommonInput
        }
      });

      return api;
    },
    // 动态模板下载 Order Shipment
    async downloadOrderDeliveryTemplate({ commit, rootState }, data) {
      const {
        data: { api }
      } = await rootState.gql.query({
        query: downloadOrderDeliveryTemplate,
        variables: {
          langInput: {
            lang: data
          }
        }
      });
      return api;
    },
    // 动态模板下载 Complete Order
    async downloadOrderReceivedTemplate({ commit, rootState }) {
      const {
        data: { api }
      } = await rootState.gql.query({
        query: downloadOrderReceivedTemplate
      });
      return api;
    },
    // 动态模板下载  Order Confirm Payment
    async downloadOrderPayTemplate({ commit, rootState }, data) {
      const {
        data: { api }
      } = await rootState.gql.query({
        query: downloadOrderPayTemplate,
        variables: {
          langInput: {
            lang: data
          }
        }
      });
      return api;
    },

    // 获取提货码
    async queryOrderPickupCode({ rootState }, orderCommonInput) {
      const {
        data: {
          api: { pickupCode }
        }
      } = await rootState.gql.query({
        query: queryOrderPickupCode,
        variables: {
          orderCommonInput
        }
      });

      return pickupCode;
    },
    async findCompressedDeclarationStatus({ commit, rootState }, variables) {
      let {
        data: { api }
      } = await rootState.gql.query({
        query: findCompressedDeclarationStatus,
        variables
      });
      return api || [];
    },
    async getPCRAttr({ commit, rootState }, variables) {
      let {
        data: { api }
      } = await rootState.gql.query({
        query: getPCRAttr,
        variables
      });
      return api || [];
    },
    async queryBaseStorePage({ commit, rootState }, variables) {
      const { searchKey = "", pageInput: { pageNum = 1, pageSize = 10 } = {} } =
        variables || {};
      const {
        data,
        data: {
          api: { pageInfo }
        }
      } = await rootState.gql.query({
        query: queryBaseStorePage,
        variables: {
          searchKey,
          pageInput: {
            pageNum,
            pageSize
          }
        }
      });

      let list = resRest(data);

      return {
        total: pageInfo.totalCount,
        list: list
      };
    }
  },
  mutations: {
    easyMutate,
    setOrderDetails(state: any, data: any) {
      state.orderDetails = data;
    }
  }
};
